import { validationMessages } from './validationMessages.schema';

export default {
  title: 'Lista płatności',
  type: 'object',
  properties: {
    filters: {
      type: 'object',
      properties: {
        year: {
          title: 'Rok',
          type: 'number',
          fieldRequired: true
        },

        month: {
          title: 'Miesiąc',
          type: 'number',
          fieldRequired: true
        },

        selectedSchool: {
          title: 'Szkoła',
          type: 'number',
          fieldRequired: false
        },

        selectedType: {
          title: 'Rodzaj listy',
          type: 'number',
          fieldRequired: false
        }
      }
    },

    split: {
      type: 'object',
      properties: {
        grant: {
          title: 'Dotacja (%)',
          type: 'number',
          fieldRequired: true
        },

        contribution: {
          title: 'Wkład własny (%)',
          type: 'number',
          fieldRequired: true
        }
      }
    },

    submit: {
      type: 'object',
      properties: {
        paymentDate: {
          format: 'date',
          fieldRequired: true,
          title: 'Termin płatności',
          type: 'string',
          validFunc: '$methods.dateDiff($methods.today(), $value).days <= 0',
          validationMessages: {
            validFunc: 'Data nie może być z przeszłości'
          }
        },

        packId: {
          type: 'number',
          title: 'Wybierz paczkę płatności'
        }
      }
    }
  },
  allOf: [validationMessages]
};
